import type { NewsletterIssue } from '../../core/types/newsletter'

/**
 * Startinhoud: één voorbeeldnieuwsbrief, zodat de maker niet leeg opent. Met een backend komt
 * dit uit GET /admin/content (AdminContent.marketing.newsletters).
 */
export const newsletters: NewsletterIssue[] = [
  {
    id: 'herfst-huid',
    subject: 'Je huid in de herfst',
    preheader: 'Waarom je huid nu anders reageert, en wat ik in de salon zie.',
    status: 'concept',
    sendDate: '',
    notes: 'Check vlak voor verzenden of beide producten op voorraad zijn.',
    blocks: [
      {
        id: 'b1',
        kind: 'text',
        heading: 'Hoi,',
        body: 'De eerste koude ochtenden zijn er weer. In de salon zie ik het meteen: huid die trekt, rode wangen, en een barrière die even wat extra aandacht nodig heeft.\n\nGeen reden om alles om te gooien. Wel om iets rijkers te kiezen voor ’s avonds.',
      },
      { id: 'b2', kind: 'products', heading: 'Wat ik nu aanraad', productIds: ['lipid-balance-cleansing-oil', 'total-moisture-daily-facial-cream'] },
      { id: 'b3', kind: 'button', label: 'Doe het huidadvies', url: 'https://beautybewust.nl/huidadvies' },
      { id: 'b4', kind: 'text', heading: '', body: 'Liefs,\n{firstName}' },
    ],
  },
  {
    id: 'zomer-spf',
    subject: 'Zon, zee en je huid',
    preheader: 'Waarom SPF ook in augustus je beste product is.',
    status: 'verstuurd',
    sendDate: '2026-08-11',
    notes: '',
    segmentId: null,
    blocks: [
      {
        id: 'b1',
        kind: 'text',
        heading: 'Hoi,',
        body: 'Pigmentvlekjes ontstaan niet in één dag, maar wel in één zomer. Smeer elke ochtend, ook als het bewolkt is.',
      },
      { id: 'b2', kind: 'button', label: 'Bekijk de zonbescherming', url: 'https://beautybewust.nl/webshop' },
      { id: 'b3', kind: 'text', heading: '', body: 'Liefs,\n{firstName}' },
    ],
  },
]
